import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  return (
    <div style={{ 
      textAlign: "center", 
      marginTop: "2em",
      minHeight: "100vh",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      padding: "40px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <div style={{
        background: "white",
        borderRadius: "10px",
        padding: "40px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        maxWidth: "600px",
        width: "100%"
      }}>
        <h1 style={{ marginBottom: "30px" }}>Page d'accueil</h1>
        <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
          <button 
            onClick={() => navigate("/lancer-traitements")} 
            style={{ 
              padding: "15px 30px",
              backgroundColor: "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px"
            }}
          >
            Lancer des traitements
          </button>
          <button 
            onClick={() => navigate("/cartographie")} 
            style={{ 
              padding: "15px 30px",
              backgroundColor: "#2196F3",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px"
            }}
          >
            Cartographie
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;